import React, { useState, useEffect } from 'react';
import { Link, Redirect, useLocation } from 'react-router-dom';
import useServerData from '../../hooks/useServerData';
import { getConsumerData } from '../../actions/actionRunner';
import { Container, Grid, Paper, Button, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FullPageContainer from '../layouts/FullPageContainer';
import ErrorMessage from '../layouts/ErrorMessage';
const useStyles = makeStyles(theme => ({
  mainContainer: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  logInContainer: {
    maxWidth: '500px',
    margin: '15px auto 15px auto',
    textAlign: 'center',
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch'
    }
  },
  logInPaper: {
    padding: '20px'
  },
  myMargin: {
    margin: '5px'
  },
  customBg: {
    backgroundColor: '#fafafa'
  }
}));
const Login = props => {
  const classes = useStyles();
  const location = useLocation();
  const fwdToken = location.state ? location.state.fwdToken : '';
  const [token, setToken] = useState(fwdToken);
  const [errorMessage, setErrorMessage] = useState(null);
  const [redirectTimer, setRedirectTimer] = useState(1000);
  const [serverToken, consumerData] = useServerData();
  function handleLogInClick() {
    getConsumerData(token).then(() => {}).catch(function (res) {
      setErrorMessage(res.error_message);
    });
  }
  function handleTokenChange(e) {
    setToken(e.target.value);
  }
  if (serverToken) {
    if (redirectTimer) {
      setTimeout(() => {
        setRedirectTimer(0);
      }, redirectTimer);
      return /*#__PURE__*/React.createElement(FullPageContainer, null, /*#__PURE__*/React.createElement(Container, {
        className: classes.mainContainer
      }, /*#__PURE__*/React.createElement(Container, {
        className: classes.logInContainer
      }, /*#__PURE__*/React.createElement(Paper, {
        elevation: 3,
        className: classes.logInPaper
      }, /*#__PURE__*/React.createElement("p", null, "Logging in...")))));
    } else {
      return /*#__PURE__*/React.createElement(Redirect, {
        to: "/home"
      });
    }
  } else {
    return /*#__PURE__*/React.createElement(FullPageContainer, null, /*#__PURE__*/React.createElement(Container, {
      className: classes.mainContainer
    }, /*#__PURE__*/React.createElement(Container, {
      className: classes.logInContainer
    }, /*#__PURE__*/React.createElement(Paper, {
      elevation: 3,
      className: classes.logInPaper
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("form", {
      className: classes.default,
      noValidate: true,
      autoComplete: "off"
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      required: true,
      id: "token-input",
      label: "Introduceti codul token",
      name: "token",
      value: token,
      onChange: handleTokenChange
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.myMargin
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: handleLogInClick
    }, "CONNECT")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.myMargin
    }, /*#__PURE__*/React.createElement(ErrorMessage, {
      value: errorMessage
    }))))))))));
  }
};
export default Login;